import React, { useState } from "react";
import AdminRollerForm from "./AdminRollerForm";

function AdminRollers({
  rollers,
  trainers,
  levels,
  canEdit,
  canAssign,
  onSave,
}) {
  const [selectedRoller, setSelectedRoller] = useState(null);

  const trainerById = trainers.reduce((acc, trainer) => {
    acc[trainer.id] = trainer;
    return acc;
  }, {});

  const levelById = levels.reduce((acc, level) => {
    acc[level.id] = level;
    return acc;
  }, {});

  const save = async (data) => {
    await onSave(selectedRoller.id, data);
    setSelectedRoller(null);
  };

  if (selectedRoller) {
    return (
      <AdminRollerForm
        roller={selectedRoller}
        trainers={trainers}
        levels={levels}
        canAssign={canAssign}
        onSave={save}
        onCancel={() => setSelectedRoller(null)}
      />
    );
  }

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h2 className="h5 mb-0">Роллери</h2>
        <span className="text-muted small">{rollers.length}</span>
      </div>

      <div className="table-responsive admin-panel__table-wrap">
        <table className="table table-sm table-hover mb-0">
          <thead>
            <tr>
              <th>Ім'я</th>
              <th>Телефон</th>
              <th>Рівень</th>
              <th>Тренер</th>
              {canEdit ? <th></th> : null}
            </tr>
          </thead>
          <tbody>
            {rollers.map((roller) => {
              const trainer = trainerById[roller.trainerId];
              const level = levelById[roller.levelId];

              return (
                <tr key={roller.id}>
                  <td>{roller.name || "Без імені"}</td>
                  <td>{roller.phone || "-"}</td>
                  <td>{level ? level.name : "-"}</td>
                  <td>{trainer ? trainer.name : "Без тренера"}</td>
                  {canEdit ? (
                    <td className="text-right">
                      <button
                        type="button"
                        className="btn btn-link btn-sm"
                        onClick={() => setSelectedRoller(roller)}
                      >
                        Редагувати
                      </button>
                    </td>
                  ) : null}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {!rollers.length ? (
        <div className="admin-panel__empty">Роллерів не знайдено.</div>
      ) : null}
    </div>
  );
}

export default AdminRollers;
